import React, { forwardRef, useId } from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";

import FormField from "./FormField";

const SearchSelect = forwardRef(({
  creatable = false,
  error,
  helpText,
  id,
  label,
  loading = false,
  noOptionsMessage = "No options found",
  optional = false,
  options,
  required = false,
  ...selectProps
}, ref) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  const SelectComponent = creatable ? CreatableSelect : ReactSelect;

  return (
    <FormField error={error} helpText={helpText} id={inputId} label={label} optional={optional} required={required}>
      {(fieldProps) => (
        <SelectComponent
          {...selectProps}
          aria-describedby={fieldProps["aria-describedby"]}
          aria-invalid={fieldProps["aria-invalid"]}
          aria-label={!label ? selectProps["aria-label"] : undefined}
          className="wsm-search-select"
          classNamePrefix="wsm-search-select"
          inputId={inputId}
          instanceId={inputId}
          isLoading={loading}
          noOptionsMessage={() => noOptionsMessage}
          options={options}
          ref={ref}
          unstyled
        />
      )}
    </FormField>
  );
});

SearchSelect.displayName = "SearchSelect";
SearchSelect.propTypes = {
  "aria-label": PropTypes.string,
  creatable: PropTypes.bool,
  error: PropTypes.string,
  helpText: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  optional: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    isDisabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
  required: PropTypes.bool,
};

export default SearchSelect;
